import React from "react";
import CardList from "./CardList";

// md:p-20 lg:px-5 sm:x-15  xs:px-5 md:w-44 md:h-44 iphone:w-16 iphone:h-16  pt-[30px] pb-20 bg-[#ffffff13]
const Projects = () => {
  return (
    <div className="md:mt-24  p-10 m-10 rounded-lg text-white">
      <div>
      <h2 className="text-white/90 font-thin  text-center text-xl md:text-4xl md:pt-5 ">
        My Work
      </h2>
      <p className="text-white/60 font-thin  text-center md:text-xl">
        A collection of projects I've worked on.
      </p>
      </div>

      {/* cards */}
      <CardList/>
     
    </div>
  );
};

export default Projects;
